import { Modal as ModalModule, Utils } from 'common';
import React, { useContext } from 'react';
import AccountCommunication from '../utils/AccountCommunication';

const { Modal, ModalButtonActionType, ModalContext } = ModalModule;
const { Logger } = Utils;

const DeleteRegionsModal = ({ data, modalId }) => {
	const { onSuccess, selectedRows } = data;
	const { showError, closeModal } = useContext(ModalContext);

	const deleteRegions = async () => {
		const response = await AccountCommunication.deleteRegions(selectedRows);
		if (AccountCommunication.isSuccessful(response)) {
			onSuccess(true);
		} else {
			showError({ response });
		}
	};

	const onDeleteButtonClick = () => {
		Logger.saveActionData('Delete Regions Button Clicked');

		closeModal(modalId, ModalButtonActionType.Confirm, deleteRegions());
	};

	const primaryButton = {
		type: ModalButtonActionType.Confirm,
		text: 'Yes',
		onClick: onDeleteButtonClick,
		dataqa: 'delete-regions-yes-button',
	};

	const secondaryButton = {
		type: ModalButtonActionType.Cancel,
		text: 'No',
		dataqa: 'delete-regions-no-button',
	};

	const renderText =
		selectedRows.length === 1
			? 'Delete this Region?'
			: `Delete ${selectedRows.length} Regions?`;

	return (
		<Modal
			modalId={modalId}
			className="account-regions account-deleteregions-modal warning-modal"
			header={`Delete Region${selectedRows.length > 1 ? 's' : ''}`}
			primaryButton={primaryButton}
			secondaryButton={secondaryButton}
			size="small"
		>
			<div className="body">
				<p>{renderText}</p>
			</div>
		</Modal>
	);
};

export default DeleteRegionsModal;
